import {useSelector} from "react-redux";

export default function useKustomerMsgDataSourceUpdateInfo() {
    const kustomerMsgDataSource = useSelector(state => state.kustomerMsgDataSource);
    const lastUpdatedHandleId = kustomerMsgDataSource.lastUpdatedHandleId;
    const error = kustomerMsgDataSource.error;
    return {lastUpdatedHandleId, error};
}
